import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_252457022 from "../../../../../packages/component/src/components/icon/demo/demo1.js?loadDemo";
import legacyImportDemo_1983977053 from "../../../../../packages/component/src/components/icon/demo/demo2.js?loadDemo";
import legacyImportDemo_4233337724 from "../../../../../packages/component/src/components/icon/demo/demo3.js?loadDemo";
import legacyImportDemo_192338843 from "../../../../../packages/component/src/components/icon/demo/demo4.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_252457022,
  legacyImportDemo_1983977053,
  legacyImportDemo_4233337724,
  legacyImportDemo_192338843,
  React
};